import * as React from 'react'
const HelpSupportIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path d="M8 11.46a.59.59 0 00-.32.09.58.58 0 00-.21.26.54.54 0 000 .33.62.62 0 00.16.3.67.67 0 00.3.16.54.54 0 00.33 0 .49.49 0 00.26-.21.58.58 0 00.1-.32.63.63 0 00-.17-.41.62.62 0 00-.45-.2zM8 3.3a3 3 0 00-3 3 .36.36 0 00.35.36.38.38 0 00.36-.36 2.28 2.28 0 011.42-2.12 2.26 2.26 0 012.47.49A2.26 2.26 0 018 8.53a.36.36 0 00-.25.11.33.33 0 00-.11.25V10a.33.33 0 00.11.25.36.36 0 00.25.11.34.34 0 00.25-.11.33.33 0 00.11-.25v-.78a3 3 0 001.92-1A3 3 0 008 3.3z" className="-primary-color" fill="#a5aab8"/>
      <path d="M8 14.4a6.45 6.45 0 01-3.56-1.08 6.35 6.35 0 01-2.35-2.87 6.42 6.42 0 01-.37-3.7 6.39 6.39 0 015-5 6.42 6.42 0 013.7.37 6.35 6.35 0 012.87 2.35A6.39 6.39 0 018 14.4zM8 2.31A5.68 5.68 0 004 12a5.69 5.69 0 104-9.69z" className="-secondary-color" fill="#d7dae0"/>
    </svg>
    
  )
}

export default HelpSupportIcon